export default "__VITE_ASSET__pq03QvO4__"